export type { GalleryItemProps } from "./gallery-item";
export { GalleryItem } from "./gallery-item";
